import {ADD_ALERT, REMOVE_ALERT} from 'constants/ActionTypes';

const alerts = (state = { alerts: [] }, action) => {
  switch (action.type) {
    case ADD_ALERT:
      return {
        ...state,
        alerts: [
          ...state.alerts,
          action.payload
        ]
      };
    case REMOVE_ALERT:
      const pos = state.alerts.indexOf(action.payload);

      if (pos === -1 || state.alerts.length == 0) {
        return state;
      }

      if (state.alerts.length == 1 && pos !== -1) {
        return {
          ...state,
          alerts: []
        }
      };

      return {
        ...state,
        alerts: [
          ...state.alerts.slice(0, pos),
          ...state.alerts.slice(pos+1, state.alerts.length)
        ]
      };
    default:
      return state;
  }
};

export default alerts;


// WEBPACK FOOTER //
// ./reducers/Alerts.js